import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import './FriendList.css';

import FriendListCell from './FriendListCell.js';

class FriendList extends Component {
  render() {
    const { className, allowDragging, users } = this.props;

    // We want the friends list to have online users first, so split out the users
    // into two arrays: active and inactive users.
    let activeFriends = users.filter((user) => user.availability !== 0);
    let inactiveFriends = users.filter((user) => user.availability === 0);

    // Then, sort both of the user lists by display name alphabetically.
    let sortedActiveFriends = _.sortBy(activeFriends, (user) => user.displayName);
    let sortedInactiveFriends = _.sortBy(inactiveFriends, (user) => user.displayName);

    // Now, assemble the sorted list of users.
    let sortedFriends = sortedActiveFriends.concat(sortedInactiveFriends);

    let friendCells = sortedFriends.map((user) => {
      return <FriendListCell key={user.id} draggable={allowDragging} user={user} />
    });

    if (!friendCells.length) {
      friendCells = <p className="text-help text-help--light">You don't have any friends on Normal Chat just yet!</p>;
    }

    let listClassNames = ['FriendList'];
    if (className) {
      listClassNames.push(className);
    }

    return (
      <section className={listClassNames.join(' ')}>
        {friendCells}
      </section>
    );
  }
};

FriendList.propTypes = {
  allowDragging: PropTypes.bool,
  users: PropTypes.array
};

export default FriendList;



// WEBPACK FOOTER //
// ./src/components/FriendList.js